class Product {
  constructor() {
    this.acc = [];
    this.container = document.querySelector(".m-main-product");
    MinimogTheme.CompareProduct && MinimogTheme.CompareProduct.setCompareButtonsState();
    MinimogTheme.Wishlist && MinimogTheme.Wishlist.setWishlistButtonsState();
    this.addRecentViewedProduct();

    addEventDelegate({
      context: this.container,
      selector: (window.__minimog_review_selector || '') + '.m-product-collapsible .jdgm-widget-actions-wrapper, .m-product-collapsible .spr-summary-actions-newreview',
      handler: (e) => {
      const index = e.target.closest('.m-product-collapsible').dataset.index
      setTimeout(() => {
        this.acc[Number(index)].setContentHeight()
      }, 300)},
      capture: true
    })
  }

  addRecentViewedProduct() {
    const cookies = getCookie('m-recent-viewed-products')
    let products = cookies ? JSON.parse(cookies) : []
    if (products.indexOf(MinimogSettings.productHandle) === -1) {
      products.unshift(MinimogSettings.productHandle)
      products = products.slice(0, 20)
      setCookie('m-recent-viewed-products', JSON.stringify(products));
    }
  }
}

// new Product();
// --- Variant image selector click logic ---
document.addEventListener('DOMContentLoaded', function() {
  const container = document.querySelector('[data-variant-selector]');
  if (!container) return;

  container.addEventListener('click', function(e) {
    const button = e.target.closest('.variant-image-button');
    if (!button) return;

    const variantId = button.dataset.variantId;
    const productForm = document.querySelector('form[action*="/cart/add"] [name="id"]');

    if (productForm) {
      productForm.value = variantId;

      // 触发 change 事件，通知Shopify变体选择器更新
      const event = new Event('change', { bubbles: true });
      productForm.dispatchEvent(event);
    }

    // 更新按钮状态
    container.querySelectorAll('.variant-image-button').forEach(btn => btn.classList.remove('active'));
    button.classList.add('active');
  });
});
